import { XIcon } from 'lucide-react'

import { RiskLevel } from '@/gen/inventory/v1/risk_pb'

import { cn } from '@/lib/ui/style-helpers'

import { RISK_LEVEL_MAP } from '@/components/shared/risk-badge/consts'

type IRQAnswerTagProps = {
  label: string
  severity: RiskLevel
  fromLemaSuggestions?: boolean
  onRemove?: () => void
}

export const IRQAnswerTag = ({
  label,
  severity,
  fromLemaSuggestions = false,
  onRemove,
}: IRQAnswerTagProps) => {
  const Icon = RISK_LEVEL_MAP[severity]?.icon

  return (
    <span
      className={cn(
        'm-0.5 flex h-6 items-center gap-1 rounded-full px-2 py-1 !text-label-small',
        fromLemaSuggestions
          ? 'bg-main-background-subtle-semantic-ai text-main-foreground-ai'
          : 'bg-main-background-neutral text-main-foreground-secondary',
      )}
    >
      {Icon && <Icon className='size-3.5' aria-hidden='true' />}
      <span>{label}</span>
      {onRemove && (
        <button
          type='button'
          aria-label='Remove'
          onMouseDown={(e) => {
            e.preventDefault()
            e.stopPropagation()
          }}
          onClick={onRemove}
          className='flex size-4 shrink-0 items-center justify-center text-main-foreground-tertiary'
        >
          <XIcon className='size-4' aria-hidden='true' />
        </button>
      )}
    </span>
  )
}
